import React, { useEffect, useState } from "react";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { TextField, Popover } from "@mui/material";
import { calender_icon } from "../../assets/img";

const formatDate = (date) => {
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

const DateRangeMUI = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  blockedDatesArray = [],
  isKeyValue,
  setIsKeyValue,
}) => {
  const [anchorElFrom, setAnchorElFrom] = useState(null);
  const [anchorElTo, setAnchorElTo] = useState(null);
  const [selectedDates, setSelectedDates] = useState({
    from: fromDate || "",
    to: toDate || "",
  });

  console.log("blockedDatesArray", selectedDates);
  const openFromPicker = (event) => setAnchorElFrom(event.currentTarget);
  const closeFromPicker = () => setAnchorElFrom(null);

  const openToPicker = (event) => setAnchorElTo(event.currentTarget);
  const closeToPicker = () => setAnchorElTo(null);

  const handleFromChange = (date) => {
    const formatted = formatDate(date);
    setSelectedDates({ from: formatted, to: "" });
    setFromDate?.(formatted);
    setToDate?.("");
    closeFromPicker();
  };

  const handleToChange = (date) => {
    const formatted = formatDate(date);
    setSelectedDates((prev) => ({ ...prev, to: formatted }));
    setToDate?.(formatted);
    closeToPicker();
  };

  // Disable dates where can_block is false
  const isDateBlocked = (date) => {
    // if (!Array.isArray(blockedDatesArray)) return false;

    return blockedDatesArray.some((item) => {
      if (!item.can_block) {
        const bd = new Date(item.date);
        return (
          date.getDate() === bd.getDate() &&
          date.getMonth() === bd.getMonth() &&
          date.getFullYear() === bd.getFullYear()
        );
      }
      return false;
    });
  };

  function getNextAvailableDateFromToday() {
    let currentDate = new Date(); // start from today

    // Keep moving to the next day until we find a date that is NOT blocked
    while (
      blockedDatesArray.some(
        (b) =>
          new Date(b.date).toDateString() === currentDate.toDateString() &&
          b.label === false
      )
    ) {
      currentDate.setDate(currentDate.getDate() + 1);
    }
    console.log("CURRECTIT", currentDate);
    return currentDate;
  }

  // Example usage:
  const chosenDate = getNextAvailableDateFromToday();

  console.log(
    "blockedDatesArray[1]?.date",
    blockedDatesArray[1]?.date,
    chosenDate
  );
  useEffect(() => {
    console.log("isKeyValue", isKeyValue);
    if (isKeyValue) {
      console.log("isKeyValue2", isKeyValue, fromDate, toDate);
      setSelectedDates({ from: " ", to: " " });
      setIsKeyValue(false); // ✅ correct way to reset
    }
  }, [isKeyValue]);
  return (
    <div className="d-flex ac-jb gap-2">
      {/* From Date */}
      <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
        <img
          src={calender_icon}
          alt="calendar"
          onClick={openFromPicker}
          style={{ cursor: "pointer" }}
          className="calender-icon me-2"
        />
        <div style={{ width: "115px" }}>
          <p
            className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14"
            style={{ textAlign: "left" }}
          >
            From Range:
          </p>
          <TextField
            // value={selectedDates.from}
            // placeholder="From Date"
            // onClick={openFromPicker}
            // fullWidth
            // style={{ border: "none" }}
            value={selectedDates.from}
            placeholder="From Date"
            onClick={openFromPicker}
            fullWidth
            variant="standard" // removes the outlined border
            InputProps={{ disableUnderline: true }} // removes the underline
            // sx={{ "& .MuiInputBase-root": { padding: 0 } }}
          />
          <Popover
            open={Boolean(anchorElFrom)}
            anchorEl={anchorElFrom}
            onClose={closeFromPicker}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <DateCalendar
              onChange={handleFromChange}
              shouldDisableDate={isDateBlocked}
              minDate={new Date()}
            />
          </Popover>
        </div>
      </div>

      {/* To Date */}
      <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
        <img
          src={calender_icon}
          alt="calendar"
          onClick={openToPicker}
          style={{ cursor: "pointer" }}
          className="calender-icon me-2"
        />
        <div style={{ width: "115px" }}>
          <p
            className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14"
            style={{ textAlign: "left" }}
          >
            To Range:
          </p>
          <TextField
            value={selectedDates.to}
            placeholder="To Date"
            onClick={openToPicker}
            fullWidth
            variant="standard" // removes the outlined border
            InputProps={{ disableUnderline: true }} // removes the underline
            sx={{ "& .MuiInputBase-root": { padding: 0 } }}
          />
          <Popover
            open={Boolean(anchorElTo)}
            anchorEl={anchorElTo}
            onClose={closeToPicker}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <DateCalendar
              minDate={
                selectedDates.from ? new Date(selectedDates.from) : undefined
              }
              onChange={handleToChange}
              shouldDisableDate={isDateBlocked}
              // maxDate={chosenDate}
            />
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default DateRangeMUI;
